//@flow

import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { BruImage, ContinueLink } from "@/components/index";
import { classNameOf } from "@/utils";

type Props = {
    title: string,
    className?: string,
    body: React$Node,
    link: Link,
    image: ImageSharp,
};

const SocialInvestmentsPost = ({title, body, link, image, className}: Props): React$Element<'div'> => (
    <Row
        className={classNameOf("social-investments-post", className || "")}
    >
        <Col md={{ span: 5, order: 1 }} xs={{ span: 12, order: 2 }}>
            <h3 className="mb-4">{title}</h3>
            <div className="text-muted mb-4">{body}</div>
            {link.text !== "" && (
                <ContinueLink
                    to={link.path}
                    target={link.target}
                    variant="boxed-light-gray"
                >
                    {link.text}
                </ContinueLink>
            )}
        </Col>

        <Col
            md={{ span: 7, order: 1 }}
            xs={{ span: 12, order: 1 }}
            className="pb-4 pb-md-0 mb-2 mb-md-0 deeper-col"
        >
            <div className={"image-wrapper"}>
                <BruImage image={image} alt={`Image ${title}`} />
            </div>
        </Col>
    </Row>
);

export default SocialInvestmentsPost;
